import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCM: CultureInfo = {
  name: 'en-CM',
  displayName: 'English (Cameroon)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CM',
  parent: CultureInfoEn
};
